import { createBlock } from 'factories/block';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import Correct_default from 'assets/Feedback - Correct.svg';
// references to old images. . .
//
// CC_Correct.png';
// CC_Scorable Images_Correct.png';
import Incorrect_default from 'assets/Feedback - Incorrect.svg';
// CC_Incorrect.png';
// CC_Scorable Images_Incorrect.png';
import Attempt_default from 'assets/Feedback - Retry.svg';
// CC_TryAgain.png';
// CC_Scorable Images_Number of Atempts.png';
import { createMediaBlock } from './media';

export const createFeedbackBlock = ({ ...props }) => {
  const label = props.label || 'Continue';

  return createBlock(
    'Feedback',
    [
      createBlock(
        'Correct',
        [
          createMediaBlock({
            src: Correct_default,
            child: 1,
            useBackgroundControls: false,
          }),
          createBlock('Text'),
          createContinueBtn({
            unlocked: true,
            removeable: false,
          }),
        ],
        {
          props: { type: 'Correct_Feedback' },
          meta: {
            subType: 'Correct_Feedback',
          },
        }
      ),
      createBlock(
        'Incorrect',
        [
          createMediaBlock({
            src: Incorrect_default,
            child: 1,
            useBackgroundControls: false,
          }),
          createBlock('Text'),
          createContinueBtn({
            unlocked: true,
            removeable: false,
          }),
        ],
        {
          props: { type: 'Incorrect_Feedback' },
          meta: {
            subType: 'Incorrect_Feedback',
          },
        }
      ),
      createBlock(
        'Attempt',
        [
          createMediaBlock({
            src: Attempt_default,
            child: 1,
            useBackgroundControls: false,
          }),

          createBlock('Text'),
          createEditableBtn({
            type: 'Feedback_Button_Attempt',
            label: 'Try again',
          }),
        ],
        {
          props: { type: 'Attempt_Feedback' },
          meta: {
            subType: 'Attempt_Feedback',
          },
        }
      ),
      createEditableBtn({ type: 'Feedback_Button', label }),
    ],
    {
      props: {
        type: 'Feedback',
        name: props.name || '',
        style: props.style || {},
      },
      meta: {
        subType: 'Feedback',
      },
    }
  );
};
